import { Button } from "@simplicity/ui";

export function Login() {
  const apiBase = import.meta.env.VITE_API_URL ?? "";
  const loginUrl = `${apiBase}/auth/google/login`;

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center p-8">
      <div className="login-card">
        <h2 className="mb-3 text-2xl font-semibold text-card-foreground">Sign in to Simplicity</h2>
        <p className="mb-7 text-base text-muted-foreground">
          Use your @simplicityed.com account to continue.
        </p>
        <Button
          size="lg"
          className="text-base font-semibold"
          onClick={() => {
            window.location.href = loginUrl;
          }}
        >
          Continue with Google
        </Button>
      </div>
    </div>
  );
}
